import React from 'react';
import { createRoot } from 'react-dom/client';
import './globals.css';
import AdminApp from './components/AdminApp';
// Import config to ensure it's loaded at build time
import './config/AppConfig';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>
);

